// Hands an access code to the new /shop (Shop::StoreController#enter) for a
// school piloting it (Shop::SCHOOL_PICTURES_FLAG). A real form POST, not fetch:
// #enter answers with a redirect into the shop, which the browser should follow
// as a page load. #enter strips the printed S-/P-/M- prefix itself.
export default function enterShop({ schoolId, accessCode, email }, doc = document) {
  const form = doc.createElement('form');
  form.method = 'post';
  form.action = '/shop/enter';
  form.style.display = 'none';

  const fields = {
    authenticity_token: doc.querySelector('meta[name="csrf-token"]')?.content,
    school_id: schoolId,
    access_code: accessCode,
    email,
  };
  Object.entries(fields).forEach(([name, value]) => {
    const input = doc.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value ?? '';
    form.appendChild(input);
  });

  doc.body.appendChild(form);
  form.submit();
}
